import { type NotificationType } from "./NotificationType";
import { type ReactNode } from "react";
import { type NotificationRegistry, NotificationRegistryImpl } from "./NotificationRegistry";
import { type ExpireQuoteNotificationData, ExpireQuoteNotificationDefinition } from "./templates/ExpireQuote";
import { type StatusChangeQuoteData, StatusChangeQuoteNotificationDefinition } from "./templates/StatusChangeQuoteData";
import { type GeneralNotificationData, GeneralNotificationDefinition } from "./templates/GeneralNotification";
import { type ReleaseNotesNotificationData, ReleaseNotesNotificationDefinition } from "./templates/ReleaseNotes";

export interface NotificationDefinition<T extends BaseNotificationData> {
  type: NotificationType;
  renderTitle: (data: T, context: NotificationContext) => ReactNode;
  renderTitleGA: (data: T, context: NotificationContext) => string;
  renderContents: (data: T, context: NotificationContext) => ReactNode;
}

export interface NotificationContext {
  markAsRead: (data: NotificationData, isRead?: boolean) => Promise<void>;
}

export interface BaseNotificationData {
  uid: string;
  notificationDate: number;
  read: boolean;
  subType: string;
  subTypeCode: NotificationType;
  type: string;
  typeCode: string;
}

export type NotificationData =
  | ExpireQuoteNotificationData
  | StatusChangeQuoteData
  | GeneralNotificationData
  | ReleaseNotesNotificationData;

const registry = new NotificationRegistryImpl();
registry.addNotificationDefinition(ExpireQuoteNotificationDefinition);
registry.addNotificationDefinition(StatusChangeQuoteNotificationDefinition);
registry.addNotificationDefinition(GeneralNotificationDefinition);
registry.addNotificationDefinition(ReleaseNotesNotificationDefinition);

export const Notifications: NotificationRegistry = registry;
